
export const name = "hubspot-dlb";
export const version = "2.1828";
